import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
const Testimonials = () => {
  const [selectedTestimonial, setSelectedTestimonial] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const messages = await getPrincipalMessage();
      const filterData = messages.filter(
        (item) => item.school === "FARRUKHABAD" && item.category === "Chairman",
      );
      setData(filterData);
    };
    fetchData();
  }, []);

  const testimonials = [
    {
      name: data[0]?.name || "Mr. Manoj Agarwal",
      designation: data[0]?.designation || "Chairman",
      message: "Principal’s Message",
      description:
        data[0]?.message ||
        "Gayatri International School has been conceived with the idea of providing a completely different model of education: the one that seeks to meet and in fact exceed the expectations of the aspirational class of the society. GIS as part of its mission aspires to provide learners a world-class education that gives them a distinct edge in life. I am optimistic of the school fulfilling this long-felt need that has not been addressed so far. The educational model of GIS will not only provide each child a world-class education but also endow them with a comprehensive range of skills to enable them to compete with the best besides emerging truly successful. The school has put in place a superior infrastructure and modern facilities that will enable every learner to turn his/her dreams into reality. To put it simply, GIS is the place where ‘dreams come true’ as reflected in the tag line of the school.",

      image: data[0]?.attachments
        ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`
        : "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/chaireman_img.jpg",
      link: "/ChairmanMessage",
    },
    // Add more testimonials as needed
  ];

  const handleTestimonialClick = (index) => {
    setSelectedTestimonial(selectedTestimonial === index ? 0 : index);
  };

  return (
    <div className="message-container">
      <div className="messageimg">
        {testimonials.map((testimonial, index) => (
          <div key={index} className="testimonial">
            <img
              src={testimonial.image}
              alt={testimonial.name}
              onClick={() => handleTestimonialClick(index)}
              className={selectedTestimonial === index ? "active" : ""}
            />
            <p className="text-center mt-4">
              {testimonials[selectedTestimonial].name}{" "}
              <span>{testimonials[selectedTestimonial].designation}</span>{" "}
            </p>
          </div>
        ))}
      </div>
      <div className="messagebox">
        <div
          className={`${selectedTestimonial !== 0 ? "slide-in" : "slide-out"}`}
        >
          {selectedTestimonial !== null && (
            <div>
              <div className="messagedesc">
                {/* <div className="maintitle"> <h3>{testimonials[selectedTestimonial].message}</h3></div> */}
                <p>{testimonials[selectedTestimonial].description}</p>
              </div>

              <Link to={testimonials[selectedTestimonial].link}>
                {" "}
                <button className="readmore">Read More</button>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
